import {
  TERMINAL_MODEL_FIELD_FILTER_REQUEST,
  TERMINAL_MODEL_FIELD_FILTER_REQUEST_SUCCESS,
  TERMINAL_MODEL_FIELD_FILTER_REQUEST_FAILURE,
  TERMINAL_MODEL_FIELD_FILTER_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const terminalModelFilterFieldsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_MODEL_FIELD_FILTER_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TERMINAL_MODEL_FIELD_FILTER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case TERMINAL_MODEL_FIELD_FILTER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TERMINAL_MODEL_FIELD_FILTER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};

export default terminalModelFilterFieldsReducer;
